module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headerTooltip":"Manufacturer\u0027s purchased products in the selected time range in all stores (displayed, not illuminated)"}}')
  delete Component.options._Ctor
}
